import React from 'react';
import ProductItem from './ProductItem';
import products from '../data/products';

export default function ProductGrid() {
  return (
    <section id="products" className="products">
      <h2 className="section-title">100% ערביקה</h2>
      <p className="section-subtitle">טעם עמוק ונקי, בלי טעמי לוואי. קלייה איטית מסורתית – פולים שנותנים לקפה לדבר בעד עצמו</p>
      <div className="product-grid">
        {products.map((p) => (
          <ProductItem key={p.id} product={p} />
        ))}
      </div>
    </section>
  );
}
